export default {
    getPhotoValidCode: "/gateway/manageBedrock/messagecs/createImageCode", //获取图片验证码
};



// WEBPACK FOOTER //
// ./src/components/VerificationCode/api.js